import React from 'react'

const StorySection = () => {
    return (
        <section className="story-sec bsbb">
            <p className="fs1rem fw400 mb1-5rem tal">
                Originally the three of us got together in 2021 with the intention of finding one or more companies in which to become active non-executive investors together.  We became frustrated by the time we wasted on early-stage companies with impressive pitch decks which did not withstand our cursory due diligence and which was time-wasting for everyone – including the companies themselves .The process is also frustrating and inefficient for management teams, who can spend 50% of their precious time seeking investment or exit  – and for whom each diligence process is a discrete, differently formatted exercise.
            </p>
            <p className="fs1rem fw400 mb1-5rem tal">
                We thought that there must be a better answer.  Using technology to do the heavy lifting wherever possible.
            </p>
            <p className="fs1rem fw600 mb1-5rem tal">
                So we developed the concept of an automated, re-usable, self-diligence platform.
            </p>
            <p className="fs1rem fw400 tal">
                We have spent the last two years building Diligentsia for launch later in 2024.  As more users come on board we will build out more features of use to the circular community we are creating.
            </p>
        </section>
    )
}

export default StorySection